 <!-- dr panel (start) -->
 <div class="drPanel">
    
        <i class="drPanel-icon icon-dr"></i>

        <div class="drPanel-info">
            <figure class="drPanel-image">
                <img src="assets/images/dr.jpg" alt=""/>
            </figure>
            <div class="drPanel-desc">
                <div class="drPanel-name">
                    {{loginService.getUserName()}}
                </div>
                <div class="drPanel-detail">
                    <ng-container *ngIf="sites.hasSites && !disableSiteSwitch; else plainClinic">
                        <select
                            class="t-field t-select site-switcher-select"
                            [ngModel]="sites.activeSite"
                            (ngModelChange)="onSiteSwitch($event)"
                            matTooltip="Switch clinic"
                        >
                            <option *ngFor="let s of sites.sites" [ngValue]="s.GID">{{ s.ClinicTitle }}</option>
                            <option [ngValue]="'all'">All Sites</option>
                        </select>
                    </ng-container>
                    <!-- Inside an exam, the clinic is fixed for the duration of the exam —
                         switching mid-exam is disallowed, so this shows read-only, same as
                         for non-site users. -->
                    <ng-template #plainClinic>{{loginService.Clinic ? loginService.Clinic : ''}}</ng-template>
                </div>
            </div>
        </div>

        <div class="drPanel-controls">
            <a class="drPanel-controls-item drPanel-controls-icon-gear" style='cursor: pointer;' [matMenuTriggerFor]="menu">
                Settings
            </a>
            <mat-menu #menu="matMenu">
                <a mat-menu-item (click)="goDefaults()" routerLink="/defaults">Defaults</a>
                <a mat-menu-item routerLink="/Custom" *ngIf="!loginService.isCardio && ! loginService.isGastro && false">Custom Header</a>
                <a mat-menu-item routerLink="/Stats" *ngIf="(loginService.premissions && loginService.premissions.Stats) || loginService.isAdmin">Stats</a>
                <a mat-menu-item (click)="redirectAdministration('questionnaires')" *ngIf="loginService.premissions && loginService.premissions.Questionnaires">Questionnaires</a>
                <a mat-menu-item (click)="showLimits = true" *ngIf="loginService.isAdmin && loginService.premissions && loginService.premissions.Limits">Limits</a>
                <a mat-menu-item (click)="showLogin = true" *ngIf="loginService.ishospital && loginService.isAdmin">Export Data</a>
                <a mat-menu-item routerLink="/Searchdata" *ngIf="loginService.ishospital && loginService.isAdmin">Search By Text</a>
                <a mat-menu-item>Language</a>
                <a mat-menu-item>Measurements</a>
            </mat-menu>
            <a (click)="logout()" class="drPanel-controls-item drPanel-controls-icon-logout" style='cursor: pointer;'>
                Logout
            </a>
        </div>
    <app-loginbox *ngIf="showLogin" (closed)="showLogin=false;" [isExport]="true"></app-loginbox>
    <app-limits *ngIf="showLimits" (closed)="showLimits=false;"></app-limits>

</div>
    <!-- dr panel (end) -->
